// extracted by mini-css-extract-plugin
module.exports = {"shareHeading":"VideoShare_shareHeading__ACkYg","contentBookAgain":"VideoShare_contentBookAgain__ZoJ7J"};